<template>
    <button
        class="group relative flex items-center bg-transparent rounded-t-md shrink-0 px-6 | transition duration-200 | focus:outline-none"
        :class="textClassName"
        :disabled="isDisabled"
        type="button"
        @click="$emit('click')"
        v-tooltip="tooltip"
    >
        <div
            class="
                flex-1 flex flex-col pointer-events-none rounded
                group-focus-visible:ring-2 group-focus-visible:ring-offset-2 group-focus-visible:ring-blue-500
            "
            :class="textAlignmentClassName"
        >
            <div class="truncate" v-text="label" />
            <div class="text-xs text-gray-500 truncate" v-text="subLabel" v-if="subLabel" />
        </div>
        <div class="flex items-center h-full absolute top-0 right-0 mr-2" v-if="isActive">
            <slot name="moreButtons" />
        </div>
        <div
            class="absolute right-0 h-5 w-px -mr-px bg-gray-350 | transition duration-200"
            :class="{ 'group-hover:bg-transparent': !isDisabled }"
            v-if="!isActive && !hideSeparator"
        />
    </button>
</template>

<script>
    export default {
        name: 'ActivixTab',

        props: {
            label: {
                type: String,
                required: true,
            },
            subLabel: {
                type: String,
                default: '',
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
            tooltip: {
                type: String,
                default: '',
            },
            hideSeparator: {
                type: Boolean,
                default: true,
            },
            textAlignment: {
                type: String,
                default: 'center',
                validator: value => ['left', 'center'].includes(value),
            },
        },

        computed: {
            textClassName() {
                if (this.isDisabled) {
                    return 'cursor-not-allowed text-gray-500';
                }

                if (this.isActive) {
                    return 'text-gray-700 font-semibold';
                }

                return 'text-gray-600 hover:bg-gray-300 hover:text-gray-700';
            },

            textAlignmentClassName() {
                return {
                    left: 'text-left',
                    center: 'text-center',
                }[this.textAlignment];
            },
        },
    };
</script>
